import { Radio } from "@headlessui/react";
import React, { FC } from "react";
import RadioStyled from "../radioComponent/radioStyled";

interface Props {
  id: string;
  value: number | boolean | string;
  disabled?: boolean;
  children: React.ReactNode;
  hideRadio?: boolean;
  smallPadding?: boolean;
}

interface ISelectionBoxProps {
  children: React.ReactNode;
  smallPadding?: boolean;
}

const SelectionBox: FC<ISelectionBoxProps> = ({ children, smallPadding = false }) => {
  return (
    <div
      className={`flex items-center ${smallPadding ? "p-1" : "py-4 px-6"} w-full space-x-6 min-h-8 border border-greyBorder dark:border-blueBorderDark
        group-data-checked:border-l-blueDark group-data-checked:border-l-4 group-data-checked:bg-blueHover dark:group-data-checked:bg-blueHoverDark bg-pageBoxBackgroundLight dark:bg-pageBoxBackgroundDark
    rounded-md transition-all duration-450 min-w-14 cursor-pointer hover:bg-blueHover dark:hover:bg-blueHoverDark hover:shadow-md`}
    >
      {children}
    </div>
  );
};

/**
 * Component for a radio button.
 * @param interface
 * @returns a radio button.
 */
const RadioComponentWithSelectionBox = ({
  id,
  value,
  disabled = false,
  children,
  hideRadio = false,
  smallPadding = false,
}: Props) => {
  return (
    <Radio value={value} disabled={disabled} className="group flex items-center hover:cursor-pointer">
      <SelectionBox smallPadding={smallPadding}>
        {!hideRadio && <RadioStyled id={id} />}
        {children}
      </SelectionBox>
    </Radio>
  );
};

export default RadioComponentWithSelectionBox;
